var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPyAlt4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_62)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 175.5,
    r: 11.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 25.5,
    r: 11.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.175 200C108.816 199.991 116.443 199.338 123.975 198.05C144.175 194.475 147.825 187.025 147.825 173.25V155H100V149H165.75C179.6 149 191.75 140.675 195.55 124.825C200 106.65 200 95.3 195.55 76.325C192.15 62.2 184.05 52.125 170.2 52.125H153.775V73.925C153.602 81.7601 150.402 89.2239 144.846 94.7515C139.291 100.279 131.811 103.441 123.975 103.575H76.325C73.1678 103.601 70.0468 104.249 67.1403 105.483C64.2338 106.716 61.5989 108.51 59.3862 110.762C57.1735 113.014 55.4264 115.68 54.2448 118.608C53.0632 121.536 52.4703 124.668 52.5 127.825V173.25C52.5 186.175 63.4 195.9 76.35 198.05C84.5561 199.391 92.8601 200.044 101.175 200ZM126.975 185.375C125.17 185.405 123.397 184.897 121.882 183.917C120.366 182.936 119.176 181.527 118.464 179.868C117.751 178.21 117.548 176.377 117.88 174.603C118.212 172.828 119.064 171.193 120.328 169.904C121.592 168.616 123.211 167.732 124.979 167.366C126.746 166.999 128.583 167.167 130.255 167.847C131.927 168.528 133.358 169.69 134.368 171.186C135.378 172.682 135.92 174.445 135.925 176.25C135.945 178.646 135.014 180.952 133.336 182.663C131.658 184.373 129.371 185.349 126.975 185.375Z",
    fill: "url(#paint0_linear_9_62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5249 149V127.825C46.5935 119.894 49.739 112.299 55.2982 106.642C60.8575 100.985 68.3961 97.7071 76.3249 97.5H123.975C130.329 97.3696 136.38 94.7603 140.836 90.2294C145.292 85.6985 147.8 79.605 147.825 73.25V27.875C147.825 14.95 136.6 7.35002 123.975 3.65001C108.463 -1.21074 91.8364 -1.21074 76.3249 3.65001C64.2999 7.12502 52.4999 14.125 52.4999 27.875V46.075H99.9999V52.125H28.5999C14.7499 52.125 9.57494 61.8 4.74994 76.325C-0.250061 91.325 -0.0250702 105.65 4.74994 124.825C8.17494 138.625 14.7499 149 28.5999 149H46.5249ZM73.3249 34C71.518 34.0298 69.7431 33.5209 68.2264 32.5381C66.7098 31.5554 65.5201 30.1433 64.809 28.4819C64.0979 26.8204 63.8976 24.9849 64.2337 23.2092C64.5697 21.4335 65.4268 19.7981 66.6958 18.5114C67.9648 17.2246 69.5882 16.3449 71.3591 15.9843C73.1299 15.6236 74.9681 15.7984 76.6392 16.4864C78.3103 17.1744 79.7388 18.3444 80.7425 19.8473C81.7462 21.3501 82.2797 23.1178 82.2749 24.925C82.2816 27.3077 81.3432 29.5957 79.6654 31.2875C77.9877 32.9793 75.7076 33.9368 73.3249 33.95V34Z",
    fill: "url(#paint1_linear_9_62)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_62",
    x1: 204.618,
    y1: 193.121,
    x2: 94.3467,
    y2: 99.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_62",
    x1: 53.9779,
    y1: 40.4038,
    x2: 93.693,
    y2: 95.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "matrix(-1 0 0 -1 200 200)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyAlt4);
export default __webpack_public_path__ + "static/media/py-alt4.b65f7ae1e08ee1272aaa571156b45898.svg";
export { ForwardRef as ReactComponent };